import { z } from '@kc3/validation';
export const PagingTriggerEventSchema = z.object({
    tenantSlug: z.string(),
    groupId: z.string().uuid(),
    groupName: z.string(),
    endpoints: z.array(z.string().min(1)),
    callerChannelId: z.string().min(1).optional(),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=paging.js.map